import GroupSelector from "./UserManagement/GroupSelector";
import { UserManagementProvider, useUserManagement } from "./UserManagement/UserManagementContext";
import { Group } from "../../types";
import { ReactNode } from "react";

type ComponentProps = {
  setGroupsWithAccess: (groups: string[]) => void;
  initiallySelected: string[];
  availableGroups?: string[];
  // Shown around the selector, and like the selector only when the org has groups.
  heading?: ReactNode;
  helpText?: ReactNode;
};

const GroupAccessComponent = ({ setGroupsWithAccess, initiallySelected, availableGroups, heading, helpText }: ComponentProps) => {
  const { groups } = useUserManagement();

  if (groups.length === 0) {
    return null;
  }

  const changeGroups = (selected: Group[]) => {
    setGroupsWithAccess(selected.map(g => g.id));
  };

  const groupList = availableGroups ? groups.filter(g => availableGroups.includes(g.id)) : groups;
  return (
    <>
      {heading}
      <GroupSelector groups={groupList} selected={initiallySelected.map(g => groups.find(gr => gr.id === g)).filter(g => !!g) as Group[] || []} onChange={changeGroups} />
      {helpText}
    </>
  );
}

const GroupAccess = ({ setGroupsWithAccess, initiallySelected, availableGroups, heading, helpText }: ComponentProps) => {
  return (
    <UserManagementProvider>
      <GroupAccessComponent availableGroups={availableGroups} initiallySelected={initiallySelected} setGroupsWithAccess={setGroupsWithAccess} heading={heading} helpText={helpText} />
    </UserManagementProvider>
  );
}

export default GroupAccess;